import { CreditRewardCategory } from "griptonite-api-client/types";

// In the order they're offered to admins, with "Other" last.
export const REWARD_CATEGORY_LABELS: Record<CreditRewardCategory, string> = {
  FOOD_AND_BEVERAGES: "Food & drink",
  SHOP: "Shop",
  PASSES: "Passes",
  CLASSES: "Classes",
  COACHING: "Coaching",
  EVENTS: "Events",
  OTHER: "Other",
};

export const REWARD_CATEGORIES = Object.keys(REWARD_CATEGORY_LABELS) as CreditRewardCategory[];
